function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Chat-Widget",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ChatWidget_MessageError",
  transform: "translate(-303.000000, -21.000000)",
  fillRule: "nonzero",
  stroke: "#FFFFFF"
}, React.createElement("g", {
  id: "noun_Mute_1954046",
  transform: "translate(304.000000, 23.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "18.4843398 5.57644462 17.8108244 4.90109665 15.7421699 6.96573186 13.6735154 4.90109665 13 5.57644462 15.0590328 7.65072765 13 9.72501068 13.6735154 10.4003586 15.7421699 8.33572344 17.8108244 10.4003586 18.4843398 9.72501068 16.4253069 7.65072765 18.4843398 5.57644462"
}), React.createElement("polygon", {
  id: "Path",
  strokeWidth: 2,
  points: "0 4.27398783 0 11.0274675 2.26108745 11.0274675 8.65948384 15.3014553 8.65948384 0 2.26108745 4.27398783"
}), React.createElement("path", {
  d: "M3.5,11.7125775 L3.5,3.53256489 L3.5,11.7125775 Z",
  id: "Path",
  strokeWidth: 2
}))));

var SvgMute = function SvgMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mute.35e0f50e.svg";
export { ForwardRef as ReactComponent };